export { useMiTiendaStore } from "./mitienda";
export { useReemplazosStore } from "./reemplazos";
export { useRolesStore } from "./roles";
export { useToolsStore } from "./tools";
export { useUsersStore } from "./users";

// Plugin para persistir en localStorage
export function piniaLocalStoragePlugin({ store }) {
  const excludedStores = ["userAccesses", "mitienda"];
  if (excludedStores.includes(store.$id)) {
    return;
  }

  store.$subscribe(() => {
    localStorage.setItem(`pinia-${store.$id}`, JSON.stringify(store.$state));
  });

  const saved = localStorage.getItem(`pinia-${store.$id}`);
  if (saved) {
    store.$patch(JSON.parse(saved));
  }
}
